/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-checkbox-tile {
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  flex-flow: column wrap;
  outline: 2px solid transparent;
  position: relative;
}
.ux-checkbox-tile--active {
  outline: 2px solid #bbd03a;
}
.ux-checkbox-tile__top-wrapper {
  height: 0;
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  width: 100%;
}
.ux-checkbox-tile__top-wrapper img {
  height: auto;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.ux-checkbox-tile__description {
  background-color: #fff;
  border-bottom: 1px solid #e2e2e2;
  height: 100%;
  left: 0;
  opacity: 0;
  overflow: hidden;
  overflow-y: auto;
  padding: 30px 30px 40px;
  pointer-events: none;
  position: relative;
  position: absolute;
  top: 0;
  transform: height 2s ease;
  transition: opacity 500ms ease-in-out;
  width: 100%;
}
.ux-checkbox-tile__description--active {
  opacity: 1;
  pointer-events: auto;
}
.ux-checkbox-tile__description-close {
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 15px;
}
.ux-checkbox-tile__bottom-wrapper {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 35px 30px;
  position: relative;
}
.ux-checkbox-tile__tag {
  background-color: #727272;
  border-radius: 2px;
  color: #fff;
  font-size: 13px;
  height: 30px;
  left: 30px;
  padding: 6px 15px;
  position: absolute;
  text-align: center;
  text-transform: uppercase;
  top: 0;
  transform: translate(0, -50%);
  width: auto;
  z-index: 10;
}
.ux-checkbox-tile__tag--warning {
  background-color: #ff9302;
}
.ux-checkbox-tile__checkbox-container {
  align-items: center;
  display: flex;
  position: relative;
}
.ux-checkbox-tile__description-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #fff;
  border: 0;
  color: #131313;
  cursor: pointer;
  display: block;
  padding: 0 10px;
  text-align: center;
  text-decoration: none;
  transform: translate(10px, 0);
  z-index: 10;
}